import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src879763043/src/codemochi-courses/src/components/routes/public/Lecture.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="objective">
  <p>
    <span>Objective:</span> Create Auth0 api functions for logging in and out of
    the app.
  </p>
    </div>
    <p>{`Now that we have an auth0 library, let's create api functions that our frontend can call for authentication related purposes. Next.js api functions take two parameters `}<inlineCode parentName="p">{`req`}</inlineCode>{` and `}<inlineCode parentName="p">{`res`}</inlineCode>{` that allow us to treat these functions much like endpoints in Express.js. The `}<inlineCode parentName="p">{`req`}</inlineCode>{` object is the HTTP request and has all the properties such as the body, headers, query string, and parameters that you'd expect. Similarly, the `}<inlineCode parentName="p">{`res`}</inlineCode>{` object is what we send when we get an HTTP request. This code is pulled from the official Auth0 repository example application for a (Next.js application)`}{`[https://github.com/zeit/next.js/tree/master/examples/auth0]`}{`.`}</p>
    <p>{`The first method will be the login method. We can call the handleLogin method from the `}<inlineCode parentName="p">{`auth0`}</inlineCode>{` library that we created in the last video. We wrap a try/catch block around it and respond with an error in the event that something bad occurs.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pages/api/login.ts"
      }}>{`import auth0 from '../../utils/auth0';

export default async function login(req, res) {
  try {
    await auth0.handleLogin(req, res, {});
  } catch (error) {
    console.error(error);
    res.status(error.status || 500).end(error.message);
  }
}

`}</code></pre>
    <p>{`After logging in, Auth0 will redirect back to a callback function that is available on our api. This function will set a session cookie which we can use on the client to verify that we are logged in and obtain userId and other user specific information.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pages/api/callback.ts"
      }}>{`import auth0 from '../../utils/auth0';

export default async function callback(req, res) {
  try {
    await auth0.handleCallback(req, res, { redirectTo: '/' });
  } catch (error) {
    console.error(error);
    res.status(error.status || 500).end(error.message);
  }
}

`}</code></pre>
    <p>{`We also create a `}<inlineCode parentName="p">{`me`}</inlineCode>{` route which will return all of the user profile related information based on data that is stored in the session cookie.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pages/api/me.ts"
      }}>{`import auth0 from '../../utils/auth0';

export default async function me(req, res) {
  try {
    await auth0.handleProfile(req, res);
  } catch (error) {
    console.error(error);
    res.status(error.status || 500).end(error.message);
  }
}

`}</code></pre>
    <p>{`Finally, we will also create a `}<inlineCode parentName="p">{`logout`}</inlineCode>{` route which will clear the session cookie and return the user to the homepage in a non-logged in state.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pages/api/logout.ts"
      }}>{`import auth0 from '../../utils/auth0';

export default async function logout(req, res) {
  try {
    await auth0.handleLogout(req, res);
  } catch (error) {
    console.error(error);
    res.status(error.status || 500).end(error.message);
  }
}

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      